import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';
import { Badge } from '../ui/badge';
import { getImageUrl } from '../../utils/imageUtils';

export const GroupMembersTab = ({ members }) => (
  <motion.div
    key="members"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    className="max-w-2xl mx-auto"
  >
    <div className="space-y-3">
      {members.map((member) => (
        <Link
          key={member.id}
          to={`/user/${member.user?.id}`}
          className="bg-card border border-border p-4 flex items-center gap-4 hover:border-primary/50 transition-colors block"
          data-testid="group-member"
        >
          <Avatar className="h-12 w-12">
            <AvatarImage src={getImageUrl(member.user?.profile_picture)} />
            <AvatarFallback className="bg-primary/20 text-primary">
              {member.user?.name?.charAt(0)}
            </AvatarFallback>
          </Avatar>
          <div className="flex-1">
            <p className="font-medium text-white">{member.user?.name}</p>
            <p className="text-sm text-muted-foreground">
              Joined {new Date(member.joined_at).toLocaleDateString()}
            </p>
          </div>
          {member.role === 'admin' && <Badge className="bg-primary/20 text-primary">Admin</Badge>}
        </Link>
      ))}
    </div>
  </motion.div>
);
